<template>
  <div>
    <div v-loading="loading">
      <div class="d-flex pt_6 mt-2 mb-2" style="    align-items: center;">
        <div class="side-frame-success"></div>
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ $l('title_month_sales') || '月销量预估' }}
          </span>
        </div>
        <el-divider direction="vertical" v-if="!disabled"></el-divider>
        <b-button
          size="sm"
          variant="outline-success"
          @click="addStoreRegion"
          v-if="!disabled"
        >
          {{ $l('btn_addStoreRegion') || '新增店铺区域' }}
        </b-button>
      </div>
      <el-collapse v-model="activeNames">
        <div
          v-for="item in storeRegions"
          :key="item.amazonStoreRegion"
          class="mb-1"
        >
          <el-collapse-item :name="item.amazonStoreRegion">
            <template slot="title">
              <div
                style="width: 100%;display: flex;align-items: center;justify-content: space-between;"
              >
                {{ item.v_amazonStoreRegion }}
                <div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="添加行"
                    placement="top"
                  >
                    <i
                      class="el-icon-circle-plus-outline tool-btn mr-2"
                      v-if="!disabled"
                      @click.stop="onAddRow(item.amazonStoreRegion)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="清空列表数据"
                    placement="top"
                  >
                    <i
                      class="el-icon-circle-close tool-btn mr-2"
                      v-if="!disabled"
                      @click.stop="onClearTable(item.amazonStoreRegion)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除列表"
                    placement="top"
                  >
                    <i
                      class="el-icon-delete tool-btn mr-2"
                      v-if="!disabled"
                      @click.stop="delPromotion(item.amazonStoreRegion)"
                    ></i>
                  </el-tooltip>
                </div>
              </div>
            </template>
            <PredictTable
              ref="table"
              class="mt-1"
              :amzFirstDemandCode="amzFirstDemandCode"
              :amazonStoreRegion="item.amazonStoreRegion"
              :disabled="disabled"
              highlightCurrentRow
            />
          </el-collapse-item>
        </div>
      </el-collapse>
      <div
        v-if="isEmpty"
        style="display: flex;align-items: center;justify-content: center;height: 400px;"
      >
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </div>
    <el-dialog
      append-to-body
      :title="$l('dialog_title_choose_region') || '选择目标市场'"
      :visible.sync="addStoreRegionDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div>
        <el-form ref="form" :model="regionFormData" :rules="rules">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_amazonStoreRegion') || '目标市场'"
                prop="amazonStoreRegion"
              >
                <dict-select
                  v-model="regionFormData.amazonStoreRegion"
                  :selectedLabel.sync="regionFormData.v_amazonStoreRegion"
                  url="/ecom/amz/market/dictSelect"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  filterable
                  clearable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddStoreRegion()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="pushStoreRegion()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import PredictTable from './predict-table'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  components: { PredictTable },
  props: {
    disabled: { type: Boolean, default: false },
    amzFirstDemandCode: { type: String, default: '' },
  },
  data() {
    return {
      regionFormData: {
        amazonStoreRegion: '',
      },
      activeNames: [],
      storeRegions: [],
      tmpData: {},
      loading: false,
      addStoreRegionDialogVisible: false,
      rules: {
        amazonStoreRegion: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    isEmpty() {
      return !this.storeRegions || this.storeRegions.length < 1
    },
  },
  async mounted() {
    await this.init()
  },
  methods: {
    async cancelAddStoreRegion() {
      this.regionFormData.amazonStoreRegion = ''
      this.addStoreRegionDialogVisible = false
    },
    async pushStoreRegion() {
      const validateForm = await validate.formValidate([this.$refs.form])

      if (!validateForm) return
      const index = this.storeRegions.findIndex((e) => {
        return e.amazonStoreRegion == this.regionFormData.amazonStoreRegion
      })
      if (index == -1) {
        if (this.loadingOpen()) return
        await this.$api
          .ecomAmzFirstDemandPromotionGenerateApi({
            amzFirstDemandCode: this.amzFirstDemandCode,
            amazonStoreRegion: this.regionFormData.amazonStoreRegion,
          })
          .catch(() => null)
        this.loadingClose()
        this.storeRegions.push({
          ...this.regionFormData,
        })
        this.activeNames.push(this.regionFormData.amazonStoreRegion)
      }
      await this.cancelAddStoreRegion()
    },
    addStoreRegion() {
      if (!this.amzFirstDemandCode) {
        this.$message.warning('请先保存主信息')
        return
      }
      this.regionFormData.amazonStoreRegion = ''
      this.addStoreRegionDialogVisible = true
    },
    async init() {
      this.loading = true
      await this.getStoreRegion()
      this.loading = false
    },
    async onAddRow(amazonStoreRegion) {
      const confirm = await this.$confirm(
        this.$l('tips_add_row') || '是否要添加一行记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzFirstDemandPromotionSaveApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
          amazonStoreRegion,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.$message.success(this.$l('INDEX.tips_save_ok') || '保存成功')
      const index = this.storeRegions.findIndex((e) => {
        return e.amazonStoreRegion == amazonStoreRegion
      })
      await this.$refs.table[index].getData()
    },
    async getStoreRegion() {
      if (!this.amzFirstDemandCode) return
      const res = await this.$api
        .ecomAmzFirstDemandPromotionStoreRegionApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
        })
        .catch(() => null)
      this.storeRegions = res?.body.data || []
      this.activeNames = this.storeRegions.map((e) => e.amazonStoreRegion)
    },

    async delPromotion(amazonStoreRegion) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzFirstDemandPromotionDelApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
          amazonStoreRegion,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      let index = this.activeNames.findIndex((e) => e == amazonStoreRegion)
      this.activeNames.splice(index, 1)
      index = this.storeRegions.findIndex((e) => {
        return e.amazonStoreRegion == amazonStoreRegion
      })
      this.storeRegions.splice(index, 1)
    },
    async onClearTable(amazonStoreRegion) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_clear_data') || '是否要清空数据？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api.ecomAmzFirstDemandPromotionClearAllApi({
        amzFirstDemandCode: this.amzFirstDemandCode,
        amazonStoreRegion,
      })
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_clear_success') || '清空成功！',
        type: 'success',
      })
      const index = this.storeRegions.findIndex((e) => {
        return e.amazonStoreRegion == amazonStoreRegion
      })
      await this.$refs.table[index].getData()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
  .vxe-body--row {
    .vxe-body--column:first-child {
      background-color: #f8f8f9 !important;
    }
  }
  .el-collapse {
    border-top: none !important;
    border-bottom: none !important;
  }
  .el-collapse-item__header {
    font-size: 15px;
    font-weight: 600;
    height: 40px !important;
    line-height: 40px !important;
  }
}
.sku_main {
  font-size: 16px;
  font-weight: bold;
  color: #101010;
  height: 31px;
  line-height: 31px;
}

.bg-white {
  background-color: white !important;
}
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin: 3px 0 0 0 !important;
}
.label {
  font-weight: 600;
  color: #101010;
}
</style>
